import moment from "moment";

export function setCurrentVehicle(data, vehicleInfo, thisRoData) {
  let currentVehicle = {};
  let thisAdditional = vehicleInfo;

  currentVehicle.entityId = data.entityId;
  currentVehicle.entityTypeId = data.entityTypeId;
  currentVehicle.zipCode = data.customerZipCode;
  currentVehicle.saleType = data.currentSaleType;
  currentVehicle.rate = data.dealRate;
  currentVehicle.term = data.dealTerm;
  currentVehicle.payment = data.calcCurrentPayment;
  currentVehicle.paymentsRemaining = data.calcPaymentRemaining;
  currentVehicle.tradeValue = data.calcTradeValue;
  currentVehicle.downPayment = data.dealCashDown;
  currentVehicle.maturityDate = data.dealMaturityDate;
  currentVehicle.payoff = data.calcEstimatedPayoff;
  currentVehicle.estimatedMiles = data.mileageEstimate;
  currentVehicle.hasWarranty = data.dealHasExtendedWarranty;
  currentVehicle.warrantyMonthsRemaining = data.warrantyMonthsRemaining;
  currentVehicle.warrantyMilesRemaining = data.warrantyMilesRemaining;
  currentVehicle.make = data.currentMakeName;
  currentVehicle.model = data.currentModelName;
  currentVehicle.year = data.currentModelYear;
  currentVehicle.trim = data.currentTrimName;
  currentVehicle.isReplacement = false;
  currentVehicle.newUsed = data.dealNewUsed;
  currentVehicle.vin = data.currentVin;
  currentVehicle.color = data.currentExtColor;
  currentVehicle.dealDate = data.dealDate;
  currentVehicle.amountFinanced = data.currentLoanAmount;
  currentVehicle.odometerAtDelivery = data.currentOdometerAtDelivery;
  currentVehicle.estimatedMileage = data.mileageEstimatePerMonth;
  currentVehicle.dealLeaseAnnualMiles = data.dealLeaseAnnualMiles;
  currentVehicle.mileageEstimatedMaturityMileage =
    data.mileageEstimatedMaturityMileage;
  currentVehicle.currentResidual = data.currentResidual;
  currentVehicle.calcBalanceToMaturity = data.calcBalanceToMaturity;
  currentVehicle.trimId = data.currentTrimId;
  currentVehicle.customerStateId = data.customerStateId;
  currentVehicle.saleId = data.saleId;
  currentVehicle.makeId = data.currentMakeId;

  if (thisAdditional) {
    currentVehicle.serviceAppointment = thisAdditional.serviceAppointmentDate;
    currentVehicle.bank = thisAdditional.currentBankName;
    currentVehicle.bankId = data.currentBankId;
    currentVehicle.salesperson = thisAdditional.soldByName;
    currentVehicle.isSold = thisAdditional.isSold;
    currentVehicle.noLongerOwns = thisAdditional.noLongerOwns;
    currentVehicle.lastMeasuredMiles = thisAdditional.currentVehicleOdometer;
    currentVehicle.odometerReadDate =
      thisAdditional.currentVehicleLastOdometerReadingDate;
    currentVehicle.imageUrl = thisAdditional.currentVehicleImagePath;
    if (thisAdditional.defaultContract) {
      currentVehicle.keyId = thisAdditional.defaultContract.keyID;
    }
  }
  currentVehicle.preferredEquity = data.calcPreferredEquity;
  currentVehicle.customerScore = data.entityScore;
  currentVehicle.isAlert = data.isAlert;
  currentVehicle.isMileageAlert = data.isMileageAlert;
  currentVehicle.isInMarket = data.isInMarket;
  currentVehicle.isService = data.isService;
  currentVehicle.isAppointment = data.isAppointment;
  currentVehicle.isWarrantyAlert = data.isWarrantyAlert;
  currentVehicle.isContractEnd = data.isContractEnd;
  currentVehicle.isFlexAlert = data.isFlexAlert;
  currentVehicle.isInMarketEngaged = data.isInMarketEngaged;

  if (thisRoData && thisRoData.length > 0) {
    let moments = [];
    thisRoData.forEach(ro => {
      if (ro.openDate) {
        moments.push(moment(ro.openDate));
      }
    });

    let now = moment(new Date());
    let minMoment = now;
    let oldMoments = [];
    let newMoments = [];
    moments.forEach(m => {
      if (m > now) {
        newMoments.push(m);
      } else {
        oldMoments.push(m);
      }
    });
    if (newMoments.length > 0) {
      let nMoments = [];
      newMoments.forEach(nm => nMoments.push(moment(nm)));
      maxMoment = moment.min(nMoments);
    }
    if (oldMoments.length > 0) {
      let oMoments = [];
      oldMoments.forEach(om => oMoments.push(moment(om)));

      minMoment = moment.max(oMoments);
    }
    currentVehicle.recentRO = minMoment < now ? minMoment : null;

    let lastRo = thisRoData.data.find(ro => {
      return ro.openDate === minMoment._i;
    });
    if (lastRo && moment(lastRo.openDate) < now._i) {
      currentVehicle.serviceAdvisor = lastRo.serviceAdvisor;
    }
  }
  if (!currentVehicle.lastMeasuredMiles) {
    currentVehicle.lastMeasuredMiles = "Unknown";
  }
  if (!currentVehicle.serviceAdvisor) {
    currentVehicle.serviceAdvisor = "Unknown";
  }
  return currentVehicle;
}
export function setCurrentVehicleNew(vehicle) {
  let currentVehicle = {};
  currentVehicle.entityId = vehicle.entityId;
  currentVehicle.entityTypeId = vehicle.entityTypeId;
  currentVehicle.zipCode = vehicle.zipCode;
  currentVehicle.saleType = vehicle.saleType;
  currentVehicle.rate = vehicle.rate;
  currentVehicle.term = vehicle.term;
  currentVehicle.payment = vehicle.payment;
  currentVehicle.paymentsRemaining = vehicle.paymentsRemaining;
  currentVehicle.tradeValue = vehicle.tradeValue;
  currentVehicle.downPayment = vehicle.downPayment;
  currentVehicle.maturityDate = vehicle.maturityDate;
  currentVehicle.payoff = vehicle.payoff;
  currentVehicle.estimatedMiles = vehicle.estimatedMiles; //estimated current miles
  currentVehicle.hasWarranty = vehicle.hasWarranty;
  currentVehicle.warrantyMonthsRemaining = vehicle.warrantyMonthsRemaining;
  currentVehicle.warrantyMilesRemaining = vehicle.warrantyMilesRemaining;
  currentVehicle.make = vehicle.make;
  currentVehicle.model = vehicle.model;
  currentVehicle.year = vehicle.year;
  currentVehicle.trim = vehicle.trim;
  currentVehicle.isReplacement = false;
  currentVehicle.newUsed = vehicle.newUsed;
  currentVehicle.vin = vehicle.vin;
  currentVehicle.color = vehicle.color;
  currentVehicle.dealDate = vehicle.dealDate;
  currentVehicle.amountFinanced = vehicle.amountFinanced;
  currentVehicle.odometerAtDelivery = vehicle.odometerAtDelivery;
  currentVehicle.mileageEstimatePerMonth = 0; //need to change in vue file
  //vehicle.mileageEstimatePerMonth;//estimated monthly mileage
  currentVehicle.dealLeaseAnnualMiles = vehicle.dealLeaseAnnualMiles;
  currentVehicle.mileageEstimatedMaturityMileage =
    vehicle.mileageEstimatedMaturityMileage;
  currentVehicle.currentResidual = vehicle.currentResidual;
  currentVehicle.calcBalanceToMaturity = vehicle.calcBalanceToMaturity;
  currentVehicle.trimId = vehicle.trimId;
  currentVehicle.customerStateId = vehicle.customerStateId;
  currentVehicle.makeId = vehicle.makeId;

  currentVehicle.serviceAppointment = vehicle.serviceAppointmentDate;
  currentVehicle.bank = vehicle.bank;
  currentVehicle.bankId = vehicle.bankId;
  currentVehicle.salesperson = vehicle.soldByName;
  currentVehicle.noLongerOwns = !vehicle.stillOwn;
  currentVehicle.lastMeasuredMiles = vehicle.lastMeasuredMiles;
  currentVehicle.odometerReadDate = vehicle.odometerReadDate;
  currentVehicle.imageUrl = vehicle.imageUrl;

  currentVehicle.preferredEquity = vehicle.preferredEquity;
  currentVehicle.customerScore = vehicle.customerScore;
  currentVehicle.isAlert = vehicle.isAlert;
  currentVehicle.isMileageAlert = vehicle.isMileageAlert;
  currentVehicle.isInMarket = vehicle.isInMarket;
  currentVehicle.isService = vehicle.isService;
  currentVehicle.isAppointment = vehicle.isAppointment;
  currentVehicle.isWarrantyAlert = vehicle.isWarrantyAlert;
  currentVehicle.isContractEnd = vehicle.isContractEnd;
  currentVehicle.isFlexAlert = vehicle.isFlexAlert;
  currentVehicle.isInMarketEngaged = vehicle.isInMarketEngaged;

  currentVehicle.recentRO = vehicle.recentRODate;

  currentVehicle.serviceAdvisor = vehicle.serviceAdvisor;
  if (!currentVehicle.lastMeasuredMiles) {
    currentVehicle.lastMeasuredMiles = "Unknown";
  }
  if (!currentVehicle.serviceAdvisor) {
    currentVehicle.serviceAdvisor = "Unknown";
  }
  return currentVehicle;
}
export function setReplacementVehicle(data, vehicleInfo, thisRoData) {
  let replacementVehicle = {};
  let thisAdditional = vehicleInfo;
  replacementVehicle.isReplacement = true;
  replacementVehicle.trimId = data.calcReplacementTrimId;
  replacementVehicle.makeId = data.calcReplacementMakeId;
  //replacementVehicle.vin = data.replacementVehicle.vin;
  if (thisAdditional) {
    replacementVehicle.entityId = thisAdditional.entityId;
    replacementVehicle.odometer = thisAdditional.replacementOdometer;
    replacementVehicle.fuelDifference =
      thisAdditional.replacementFuelDifference;
    replacementVehicle.imageUrl = thisAdditional.calcReplacementImagePath;
    replacementVehicle.trim = thisAdditional.calcReplacementTrimName;
    replacementVehicle.model = thisAdditional.calcReplacementModelName;
    replacementVehicle.make = thisAdditional.calcReplacementMakeName;

    replacementVehicle.defaultContract = thisAdditional.defaultContract;
    replacementVehicle.contracts = thisAdditional.contracts;
    replacementVehicle.loanAmount = thisAdditional.defaultContract
      ? thisAdditional.defaultContract.financedAmount
      : null;
    replacementVehicle.year = thisAdditional.replacementYearId;

    replacementVehicle.saleType = thisAdditional.defaultContract
      ? thisAdditional.defaultContract.saleTypeName
      : null;

    replacementVehicle.price = thisAdditional.replacementPrice;
    replacementVehicle.newUsed = data.calcReplacementNewUsed;
    replacementVehicle.isAlert = data.isAlert;
    replacementVehicle.isMileageAlert = data.isMileageAlert;
    replacementVehicle.isInMarket = data.isInMarket;
    replacementVehicle.isService = data.isService;
    replacementVehicle.isAppointment = data.isAppointment;
    replacementVehicle.isWarrantyAlert = data.isWarrantyAlert;
    replacementVehicle.isContractEnd = data.isContractEnd;
    replacementVehicle.isFlexAlert = data.isFlexAlert;
    replacementVehicle.isInMarketEngaged = data.isInMarketEngaged;
    replacementVehicle.salesperson = data.ownerUserFullName;
  }

  if (thisRoData && thisRoData.length > 0) {
    let moments = [];
    thisRoData.forEach(ro => {
      if (ro.openDate) {
        moments.push(moment(ro.openDate));
      }
    });

    let now = moment(new Date());
    let minMoment = now;
    let oldMoments = [];
    let newMoments = [];
    moments.forEach(m => {
      if (m > now) {
        newMoments.push(m);
      } else {
        oldMoments.push(m);
      }
    });
    if (newMoments.length > 0) {
      let nMoments = [];
      newMoments.forEach(nm => nMoments.push(moment(nm)));
      maxMoment = moment.min(nMoments);
    }
    if (oldMoments.length > 0) {
      let oMoments = [];
      oldMoments.forEach(om => oMoments.push(moment(om)));

      minMoment = moment.max(oMoments);
    }

    let lastRo = thisRoData.data.find(ro => {
      return ro.openDate === minMoment._i;
    });
    if (lastRo && moment(lastRo.openDate) < now._i) {
      replacementVehicle.serviceAdvisor = lastRo.serviceAdvisor;
    }
  }

  if (!replacementVehicle.serviceAdvisor) {
    replacementVehicle.serviceAdvisor = "Unknown";
  }
  return replacementVehicle;
}
export function setReplacementVehicleNew(dealsheet) {
  let replacementVehicle = {};

  replacementVehicle.entityId = dealsheet.currentVehicle.entityId;
  replacementVehicle.isReplacement = true;
  replacementVehicle.trimId = dealsheet.replacementVehicle.trimId;
  (replacementVehicle.makeId = dealsheet.replacementVehicle), makeId;
  replacementVehicle.odometer = dealsheet.replacementVehicle.odometer;
  replacementVehicle.imageUrl = dealsheet.replacementVehicle.imageUrl;
  replacementVehicle.trim = dealsheet.replacementVehicle.trim;
  replacementVehicle.model = dealsheet.replacementVehicle.model;
  replacementVehicle.make = dealsheet.replacementVehicle.make;
  replacementVehicle.year = dealsheet.replacementVehicle.year;
  replacementVehicle.price = dealsheet.replacementVehicle.msrp;
  replacementVehicle.newUsed = dealsheet.replacementVehicle.newUsedCpo;
  replacementVehicle.isAlert = dealsheet.currentVehicle.isAlert;
  replacementVehicle.isMileageAlert = dealsheet.currentVehicle.isMileageAlert;
  replacementVehicle.isInMarket = dealsheet.currentVehicle.isInMarket;
  replacementVehicle.isService = dealsheet.currentVehicle.isService;
  replacementVehicle.isAppointment = dealsheet.currentVehicle.isAppointment;
  replacementVehicle.isWarrantyAlert = dealsheet.currentVehicle.isWarrantyAlert;
  replacementVehicle.isContractEnd = dealsheet.currentVehicle.isContractEnd;
  replacementVehicle.isFlexAlert = dealsheet.currentVehicle.isFlexAlert;
  replacementVehicle.isInMarketEngaged =
    dealsheet.currentVehicle.isInMarketEngaged;
  replacementVehicle.salesperson =
    dealsheet.currentVehicle.salesPersonPandoUserId;

  replacementVehicle.fuelDifference =
    dealsheet.fuelDifference &&
    dealsheet.fuelDifference.estimatedMonthlyCostDifference
      ? dealsheet.fuelDifference.estimatedMonthlyCostDifference
      : 0;

  replacementVehicle.defaultContract = dealsheet.paymentCalc.defaultContract;
  replacementVehicle.contracts = dealsheet.paymentCalc.contracts;

  if (thisRoData && thisRoData.length > 0) {
    let moments = [];
    thisRoData.forEach(ro => {
      if (ro.openDate) {
        moments.push(moment(ro.openDate));
      }
    });

    let now = moment(new Date());
    let minMoment = now;
    let oldMoments = [];
    let newMoments = [];
    moments.forEach(m => {
      if (m > now) {
        newMoments.push(m);
      } else {
        oldMoments.push(m);
      }
    });
    if (newMoments.length > 0) {
      let nMoments = [];
      newMoments.forEach(nm => nMoments.push(moment(nm)));
      maxMoment = moment.min(nMoments);
    }
    if (oldMoments.length > 0) {
      let oMoments = [];
      oldMoments.forEach(om => oMoments.push(moment(om)));

      minMoment = moment.max(oMoments);
    }

    let lastRo = thisRoData.data.find(ro => {
      return ro.openDate === minMoment._i;
    });
    if (lastRo && moment(lastRo.openDate) < now._i) {
      replacementVehicle.serviceAdvisor = lastRo.serviceAdvisor;
    }
  }

  if (!replacementVehicle.serviceAdvisor) {
    replacementVehicle.serviceAdvisor = "Unknown";
  }
  return replacementVehicle;
}



// WEBPACK FOOTER //
// ./src/lib/utilities/helpers/garageVehicles.js